
export interface Token {
    token: string | null;
    usuario: string | null;
    ip: string | null;
    tipo: string | null;
    id: string | null;
    setorId: string | null;
    setorNome: string | null;
    tipoSite: string | null; 

}

export const InitialStateToken: Token = {
    token: "",
    usuario: "",
    ip: "",
    tipo: "",
    id: "",
    setorId: "",
    setorNome: "",
    tipoSite: ""
}

//export function getToken(token: string | null, usuario: string | null, ip: string | null, tipo: string | null, id: string | null, setorId: string | null, setorNome: string | null): Token {
//    return { token, usuario, ip, tipo, id, setorId, setorNome,tipoSite };
//}
export function getToken( {token, usuario, ip, tipo, id, setorId, setorNome,tipoSite}:Token ) {
    return { token, usuario, ip, tipo, id, setorId, setorNome,tipoSite };
}
